import { render, staticRenderFns } from "./CitySelect.vue?vue&type=template&id=e2720c08&scoped=true"
import script from "./CitySelect.vue?vue&type=script&lang=ts"
export * from "./CitySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2720c08",
  null
  
)

export default component.exports